import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient, createAbortableConfig } from '@src/api/apiClient/axiosClient';
import { InAppNotificationIndexResponse } from '@src/api/types/inAppNotification';

export const inAppNotificationApiClient = {
  index: async (signal?: AbortSignal): Promise<ApiResult<InAppNotificationIndexResponse>> => {
    return await axiosClient.get('/company/in-app-notifications', {
      ...createAbortableConfig(signal),
    });
  },
  read: async (id: number): Promise<ApiResult<unknown>> => {
    return await axiosClient.put(`/company/in-app-notifications/${id}/read`, {});
  },
};
